export enum OTP_ENUM {
  SING_UP = 1,
  LOGIN = 2,
  FORGOT_PASSWORD = 3,
  UPDATE_PASSWORD = 4,
}

export enum ROLES {
  EMPLOYER = 1,
  FREELANCER = 2,
  SUB_ADMIN = 2,
  STAFF = 4,
  ADMIN = 1,
}

export enum APPROVED_STATUS {
  PENDING = 1,
  APPROVED = 2,
  REJECTED = 3,
}

export enum CATEGORY_TYPE {
  CATEGORY = 1,
  SUB_CATEGORY = 2,
}

export enum TASK_STATUS {
  PENDING = 1,
  CONFIRM = 2,
  DECLINE = 3,
  START = 4,
  COMPLETE = 5,
  CANCEL = 6,

  // PENDING: 1,
  // CONFIRM: 2,
  // DECLINE: 3,
  // START: 4,
  // COMPLETE: 5,
  // CANCEL: 6
}

export enum SKILLS {
  "Ux Designer" = 1,
  "Data Analyst" = 2,
  "Product Manager" = 3,
}

export enum INDUSTRY {
  "Ux Designer" = 1,
  "Data Analyst" = 2,
  "Product Manager" = 3,
}

export enum MEDIA_TYPE {
  IMAGE = 1,
  VIDEO = 2,
  PDF = 3,
}

export enum CERTIFICATE_TYPE {
  EDUCATION = 1,
  TRAINING = 2,
}

export enum SECURITY_DOC_TYPE {
  CIVIL_ID = 2,
  DRIVING_LISCENSE = 1,
}

export enum NOTIFICATION_ROLE {
  ALL = 1,
  EMPLOYER = 2,
  FREELANCER = 3,
}

export enum NOTIFICATION_TYPE {
  PUSH = 1,
  BROADCAST = 2,
  MAIL = 3,
  ADMIN = 4,
}

export enum GRAPH_TYPE {
  DAY = 1,
  WEEK = 2,
  MONTH = 3,
  YEAR = 4,
}

export enum BOOKING_STATUS {
  PENDING = 1,
  ACCEPT = 2,
  INACTIVE = 3,
  START = 4,
  FREELANCER_COMPLETED = 5,
  EMPLOYER_COMPLETED = 6,
  EMPLOYER_CANCEL_BEFORE_START = 7,
  EMPLOYER_CANCEL_AFTER_START = 8,
  FREELANCER_CANCEL_BEFORE_START = 9,
  FREELANCER_CANCEL_AFTER_START = 10,
  AUTOMATIC_CANCEL = 11,
}

export const BOOKING_STATUS_NAME: Record<number, string> = {
  1: "PENDING",
  2: "ACCEPT",
  3: "INACTIVE",
  4: "START",
  5: "FREELANCER_COMPLETED",
  6: "EMPLOYER_COMPLETED",
  7: "EMPLOYER_CANCEL_BEFORE_START",
  8: "EMPLOYER_CANCEL_AFTER_START",
  9: "FREELANCER_CANCEL_BEFORE_START",
  10: "FREELANCER_CANCEL_AFTER_START",
  11: "AUTOMATIC_CANCEL",
};

export enum Refun_Type {
  PENDING = 1,
  COMPLETED = 2,
}

